import React, { useState, useEffect, useContext } from 'react';
import c from 'classnames';
import {
    Menu,
    Dropdown,
    Tooltip,
    Typography
} from 'antd';
import './index.scss';
import PropTypes from 'prop-types';
import AppContext from '../../context';

export default function Header(props) {
    const { hideHeaderBg } = props;
    let ticking = false;
    const { userInfo = {} } = useContext(AppContext);
    const [canHideHeaderBg, setCanHideHeaderBg] = useState(true);
    const [inOpenPlatform, setInOpenPlatform] = useState(false);
    const [linkList] = useState([
        {
            path: './index.html',
            text: '首页',
        },
        {
            path: './kitListPage.html',
            text: '工具',
        },
        {
            path: './person.html',
            text: '个人面板',
        },
        {
            path: 'https://km.sankuai.com/docs/wmportal',
            text: '外卖平台-大前端',
            target: '_blank'
        }
    ]);

    const openPlatformList = [
        {
            path: 'https://km.sankuai.com/page/567666445',
            text: '官网文档',
        }
    ]

    // if (userInfo.login === 'zhangtengfei09' || userInfo.login === 'zhaoyan33') {
    //     openPlatformList.push(
    //         {
    //             path: './approve.html',
    //             text: '审批入口',
    //         }
    //     );
    // }

    openPlatformList.push(
        {
            path: './business.html',
            text: '业务维度配置',
        }
    );

    const logout = () => {
        if (window.location.hostname === 'localhost') {
            window.location.href = `${window.location.protocol}//${window.location.hostname}:8080/sso/logout`;
        } else {
            window.location.href = `${window.location.protocol}//${window.location.hostname}/api/sso/logout`;
        }
        const isProd = window.location.origin === 'https://gh.waimai.sankuai.com';
        if (isProd) {
            window.location.href = 'https://ssosv.sankuai.com/sson/logout?client_id=551c9d8153&redirect_uri=https%3A%2F%2Fgh.waimai.sankuai.com%2Findex.html';
        } else {
            if (window.location.hostname === 'localhost') {
                window.location.href = `https://ssosv.it.test.sankuai.com/sson/logout?client_id=91ac94efe5&redirect_uri=${encodeURIComponent(window.location.protocol + '//' + window.location.hostname + ':3002/index.html')}`;
            }
            window.location.href = `https://ssosv.it.test.sankuai.com/sson/logout?client_id=91ac94efe5&redirect_uri=${encodeURIComponent(window.location.href)}`;
        }
    };

    const getUserIcon = () => {
        const iconUrl = `${window.location.protocol}//cs-monitor.sankuai.com/api/avatar/${userInfo.login}`;
        const tooltipText = `欢迎, ${userInfo.name}`;
        const isProd = window.location.origin === 'https://gh.waimai.sankuai.com';
        if (isProd) {
            return <Tooltip placement="bottom" title={tooltipText} className="tip-wiki"><img className="user-icon" src={iconUrl} alt="" /></Tooltip>;
        } else {
            return <Tooltip placement="bottom" title={tooltipText} className="tip-wiki"><img className="user-icon" src={iconUrl} alt="" onClick={logout} /></Tooltip>;
        }
    };

    const doSomething = (y) => {
        const height = document.body.clientWidth / 2.44;
        if (y > (height - 64)) {
            setCanHideHeaderBg(false);
        } else {
            setCanHideHeaderBg(true);
        }
    }

    const scroll = (e) => {
        const last_known_scroll_position = window.scrollY;
        if (!ticking) {
            window.requestAnimationFrame(function () {
                doSomething(last_known_scroll_position);
                ticking = false;
            });
            ticking = true;
        }
    }

    useEffect(() => {

        // checkOpenPlatform()

        if (hideHeaderBg) {
            window.addEventListener('scroll', scroll);
        }
        return () => {
            if (hideHeaderBg) {
                window.removeEventListener('scroll', scroll)
            }
        }
    });

    const openMenu = (openPlatformList) => (
        <Menu style={{ padding: '8px 2px' }}>
            {
                openPlatformList.map(({ path, text }) => {
                    return (
                        <Menu.Item key="path">
                            <a rel="noopener noreferrer" href={path} target='_blank'>
                                {text}
                            </a>
                        </Menu.Item>
                    );
                })
            }
        </Menu>
    );

    const checkOpenPlatform = () => {
        const currentPathName = window.location.pathname;
        for (let i = 0; i < openPlatformList.length; i++) {
            if (openPlatformList[i] && openPlatformList[i].path && openPlatformList[i].path.substring(1) === currentPathName) {
                setInOpenPlatform(true)
                break;
            }
        }
    }

    

    return (
        <header className={c({
            'header-style': hideHeaderBg && canHideHeaderBg
        })}>
            <div className="header-con max-width">
                <div>
                    <a href='/'>
                        <img className="logo" src="https://s3plus.meituan.net/v1/mss_5a4c90a1d729431289d2c9ab38853394/waimai-debug-kit/logo-1.png" alt="" />
                        <span style={{ color: "#fff", paddingLeft: "10px", fontWeight: 500, fontSize: 18 }}>叮当猫</span>
                    </a>
                </div>
                <div className="memu">
                    <ul>
                        {
                            linkList.map(({ path, text, target }) => {
                                if (text === '开放平台') {
                                    return (
                                        <Dropdown overlay={openMenu(openPlatformList)} placement="bottomCenter" arrow key='openMenu'>
                                            <li
                                                key={Math.random()}
                                                className={c({
                                                    hover: path && (window.location.pathname.indexOf(path.substring(1)) !== -1 || inOpenPlatform)
                                                })}>

                                                <a target={target} href={path}>{text}</a>
                                            </li>
                                        </Dropdown>
                                    );
                                }
                                return (
                                    <li
                                        key={Math.random()}
                                        className={c({
                                            hover: path && window.location.pathname === path.substring(1)
                                        })}
                                    >
                                        {
                                            <a target={target} href={path}>{text}</a>
                                        }
                                    </li>
                                );
                            })
                        }
                    </ul>
                    {
                        getUserIcon()
                    }
                </div>
            </div>
        </header>
    );
}

Header.defaultProps = {
    hideHeaderBg: false,
}

Header.propTypes = {
    hideHeaderBg: PropTypes.bool.isRequired,
}